// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import axios from "axios";
// import endPoint from "../EndPoint/endpoint";

// export const GetCategoryData = createAsyncThunk(
//   "categoryData/GetCategoryData",
//   async (name, thunkAPI) => {
//     try {
//       const response = await axios.get(`${endPoint.GETCATEGORYDATA}/${encodeURIComponent(name)}`);
//       return response.data;
//     } catch (error) {
//       return thunkAPI.rejectWithValue(error.message);
//     }
//   }
// );

// const GetCategoryDataSlice = createSlice({
//   name: " ",
//   initialState: {
//     CategoryData: [],
//     error: null,
//   },
//   reducers: {
//     clearCategoryData: (state) => {
//       state.CategoryData = [];
//       state.error = null;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(GetCategoryData.fulfilled, (state, action) => {
//         state.CategoryData = action.payload;
//       })
//       .addCase(GetCategoryData.rejected, (state, action) => {
//         state.error = action.payload;
//       });
//   },
// });

// export const { clearCategoryData } = GetCategoryDataSlice.actions;
// export default GetCategoryDataSlice.reducer;



import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import endPoint from "../EndPoint/endpoint";

export const GetCategoryData = createAsyncThunk(
  "categoryData/GetCategoryData",
  async ({ name, page, limit = 50 }, thunkAPI) => {
    try {
      const response = await axios.get(
        `${endPoint.GETCATEGORYDATA}/${encodeURIComponent(name)}?page=${page}&limit=${limit}`
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// ✅ Slice setup
const GetCategoryDataSlice = createSlice({
  name: "categoryData",
  initialState: {
    CategoryData: [],
    currentPage: 1,
    totalPagesCategory: 0,
    totalItems: 0,
    error: null,
  },
  reducers: {
    clearCategoryData: (state) => {
      state.CategoryData = [];
      state.currentPage = 1;
      state.totalPagesCategory = 0;
      state.totalItems = 0;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetCategoryData.fulfilled, (state, action) => {
        state.CategoryData = action.payload || [];
        state.currentPage = action.payload?.currentPage || 1;
        state.totalPagesCategory = action.payload?.totalPages || 0;
        state.totalItems = action.payload?.totalItems || 0;
      })
      .addCase(GetCategoryData.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const { clearCategoryData } = GetCategoryDataSlice.actions;
export default GetCategoryDataSlice.reducer;
